module.exports = __webpack_public_path__ + "static/img/checked.521ef3ff.svg";